if (!customElements.get('sonic-study-summary')) {
  customElements.define('sonic-study-summary', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const button = this.querySelector('[data-study-open]');
      if (!dialog || !button) return;

      button.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('.sonic-tech__summary-body').scrollTop = 0;
      }, options);

      const isOutside = event => {
        const bounds = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < bounds.left ||
          event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
      };
      let startedOutside = false;
      // Only dismiss a gesture that starts and ends on the backdrop.
      dialog.addEventListener('pointerdown', event => {
        startedOutside = isOutside(event);
      }, options);
      dialog.addEventListener('click', event => {
        if (startedOutside && isOutside(event)) dialog.close();
        startedOutside = false;
      }, options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, options);
      dialog.addEventListener('close', () => button.focus({ preventScroll: true }), options);
    }

    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.controller?.abort();
    }
  });
}
